import { Component } from '@verndale/core';
import Choices from 'choices.js';

class Dropdown extends Component {
  setupDefaults() {
    this.choices = new Choices(this.el, {
      itemSelectText: '',
      searchEnabled: false,
      shouldSort: false
    });
  }

  setChoiceByValue(value) {
    this.choices.setChoiceByValue(value);
  }
}

export default Dropdown;
